import { Button, Form, Input, Modal } from "antd";
import React, { useRef } from "react";
import { EducacionNoFormal } from "../../../../models/JuradosModel/jurados.model";
import DocumentosService from "../../../../api/Documentos/api-documentos";
import DocumentInput from "../../../../utils/DocumentInput";
import DateInput from "../../../../utils/DateInput";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";

type ModalNoFormalProps = {
  openModal: boolean;
  setOpenModal: Function;
  datosSelected: EducacionNoFormal;
  setDatosSelected: Function;
  eduacionFormalArray: EducacionNoFormal[];
  indexDatosSelected: number;
  setEduacionFormalArray: Function;
};
export const ModalNoFormal = ({
  openModal,
  setOpenModal,
  datosSelected,
  setDatosSelected,
  eduacionFormalArray,
  indexDatosSelected,
  setEduacionFormalArray,
}: ModalNoFormalProps) => {
  const fileInputRef = useRef<any>();

  const fields = [
    { name: "nombre_educacion", value: datosSelected.nombre_educacion },
    { name: "nombre_proceso", value: datosSelected.nombre_proceso },
    { name: "duracion", value: datosSelected.duracion },
    { name: "institucion", value: datosSelected.institucion },
    { name: "fecha_inicio", value: datosSelected.fecha_inicio },
    { name: "fecha_terminacion", value: datosSelected.fecha_terminacion },
    { name: "numero_horas", value: datosSelected.numero_horas },
    { name: "ciudad", value: datosSelected.ciudad },
    { name: "path_anexo", value: datosSelected.path_anexo },
  ];


  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return setDatosSelected({ ...datosSelected, path_anexo: data.data });
    }
  };




  const formRef = useRef<any>();
  const resetForm = () => {
    formRef.current.resetFields();
    setDatosSelected(initialValues);
  };

  const guardarFormulario = (values: EducacionNoFormal) => {
    let newArrayMod = eduacionFormalArray.map((x, idx) => {
      if (idx === indexDatosSelected) {
        return {
          ...values,
        };
      }
      return x;
    });

    setEduacionFormalArray(newArrayMod);
    setOpenModal(false);
  };

  return (
    <Modal
      title={
        <>
          Editar educación no formal -{" "}
          <span
            style={{
              color: "#DD0A0A",
              fontSize: "10px",
              fontFamily: "Montserrat-Regular",
            }}
          >
            Todos los campos son obligatorios, excepto los marcados como
            opcionales.
          </span>
        </>
      }
      visible={openModal}
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.8)",
      }}
      onCancel={() => setOpenModal(false)}
      width={1600}
      footer={
        <div className="d-flex justify-content-end">
          <div className="row g-2">
            <div className="col align-self-end">
              <Button
                className="button-gray-ghost pe-1 me-0"
                key="back"
                onClick={() => setOpenModal(false)}
              >
                Cancelar
              </Button>
            </div>
            <div className="col align-self-end">
              <Button
                className="button-azul-ghost me-1"
                style={{ marginBottom: "20px" }}
                onClick={resetForm}
              >
                Limpiar campos
              </Button>
            </div>
            <div className="col align-self-end me-md-2">
              <Button
                className="button-azul-radius"
                form="educacionNoFormalModal"
                htmlType="submit"
              >
                Guardar cambios
              </Button>
            </div>
          </div>
        </div>
      }
    >
      <Form
        ref={formRef}
        name="educacionNoFormalModal"
        size="large"
        fields={fields}
        onFinish={guardarFormulario}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...datosSelected };
          for (const i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          setDatosSelected(infoupdate);
        }}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Nombre de educación no formal
            </span>
            <Form.Item
              className="no-margin"
              name="nombre_educacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={80} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Nombre del proceso
            </span>
            <Form.Item
              className="no-margin"
              name="nombre_proceso"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <Input maxLength={80} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Duración -{" "}
              <span className="font-family-Montserrat-Regular font-size-10px">
                &nbsp;Semanas
              </span>
            </span>
            <Form.Item
              className="no-margin"
              name="duracion"
              rules={[
                { required: true, message: "Campo obligatorio" },
                { max: 3, message: "Máximo 3 dígitos" },
              ]}
            >
              <Input type="number" min="1" />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Institución -{" "}
              <span className="font-family-Montserrat-Regular font-size-10px">
                &nbsp;Opcional
              </span>
            </span>
            <Form.Item className="no-margin" name="institucion">
              <Input maxLength={80} />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Ciudad
            </span>
            <Form.Item
              className="no-margin"
              name="ciudad"
              rules={[{ required: true, message: "" }]}
            >
              {/* <Select placeholder="Seleccionar">
                <Select.Option value="Medellín">Medellín</Select.Option>
              </Select> */}
              <InputTexto
                name="ciudad"
                texto={datosSelected.ciudad}
                setTexto={setDatosSelected}
                alltexto={datosSelected}
                maxLength={50}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Fecha de inicio
            </span>
            <Form.Item
              className="no-margin"
              name="fecha_inicio"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  setDatosSelected({
                    ...datosSelected,
                    fecha_inicio: fecha,
                  });
                }}
                dia={datosSelected.fecha_inicio.split("-")[2] || ""}
                mes={datosSelected.fecha_inicio.split("-")[1] || ""}
                anio={datosSelected.fecha_inicio.split("-")[0] || ""}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Fecha terminación
            </span>
            <Form.Item
              className="no-margin"
              name="fecha_terminacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  setDatosSelected({
                    ...datosSelected,
                    fecha_terminacion: fecha,
                  });
                }}
                dia={datosSelected.fecha_terminacion.split("-")[2] || ""}
                mes={datosSelected.fecha_terminacion.split("-")[1] || ""}
                anio={datosSelected.fecha_terminacion.split("-")[0] || ""}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-2 col-xxl-2 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Número de horas
            </span>
            <Form.Item
              className="no-margin"
              name="numero_horas"
              rules={[
                { required: true, message: "Campo obligatorio" },
                { max: 3, message: "Máximo 3 dígitos" },
              ]}
            >
              <Input type="number" min="1" />
            </Form.Item>
          </div>

          <div className="col-12 col-md-6 col-lg-4 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Diploma o certificado
            </span>

            <Form.Item
              className="no-margin"
              name="path_anexo"
              rules={[{ required: true, message: "Documento obligatorio" }]}
            >
              <DocumentInput
                doc={datosSelected.path_anexo}
                fileInputRef={fileInputRef}
                ancho_btn={30}
                on_change={(e) => {
                  guardarArchivo(e);
                  e.target.value = "";
                }}
                onDelete={() => {
                  setDatosSelected({
                    ...datosSelected,
                    path_anexo: "",
                  });
                }}
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

const initialValues = {
  nombre_educacion: "",
  nombre_proceso: "",
  duracion: "",
  institucion: "",
  fecha_inicio: "",
  fecha_inicio_dia: "",
  fecha_inicio_mes: "",
  fecha_inicio_año: "",
  fecha_terminacion: "",
  fecha_terminacion_dia: "",
  fecha_terminacion_mes: "",
  fecha_terminacion_año: "",
  numero_horas: "",
  ciudad: "",
  path_anexo: "",
};
